import {
  LayoutDashboard, Building2, Users, KanbanSquare, Package, CalendarClock,
  Route, Receipt, Coins, MonitorSmartphone, GraduationCap, CheckSquare,
  FileText, BarChart3, ShieldCheck, BellRing, CalendarDays, ClipboardList, UserCog,
} from "lucide-react";

// roles: which roles can see the nav item (empty = all)
export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, roles: [] },
  { to: "/todays-plan", label: "Today's Plan", icon: ClipboardList, roles: [] },
  { to: "/clinics", label: "Clinics", icon: Building2, roles: [] },
  { to: "/contacts", label: "Contacts", icon: Users, roles: [] },
  { to: "/pipeline", label: "Sales Pipeline", icon: KanbanSquare, roles: [] },
  { to: "/products", label: "Products", icon: Package, roles: [] },
  { to: "/meetings", label: "Meetings", icon: CalendarClock, roles: [] },
  { to: "/calendar", label: "Calendar", icon: CalendarDays, roles: [] },
  { to: "/mileage", label: "Mileage", icon: Route, roles: [] },
  { to: "/expenses", label: "Expenses", icon: Receipt, roles: [] },
  { to: "/commissions", label: "Commissions", icon: Coins, roles: ["admin", "director", "finance", "bdm"] },
  { to: "/devices", label: "Device Installs", icon: MonitorSmartphone, roles: [] },
  { to: "/workshops", label: "Workshops", icon: GraduationCap, roles: [] },
  { to: "/tasks", label: "Tasks", icon: CheckSquare, roles: [] },
  { to: "/reminders", label: "Reminders", icon: BellRing, roles: [] },
  { to: "/documents", label: "Documents", icon: FileText, roles: [] },
  { to: "/reports", label: "Reports", icon: BarChart3, roles: ["admin", "director", "finance"] },
  { to: "/users", label: "User Management", icon: UserCog, roles: ["admin"] },
  { to: "/audit", label: "Audit Logs", icon: ShieldCheck, roles: ["admin", "director", "finance"] },
];

export function navForRole(role) {
  return NAV.filter((n) => n.roles.length === 0 || n.roles.includes(role));
}
